// src/services/collegeService.js
import api from './api';

const collegeService = {
  /**
   * Get all active colleges (for dropdown filter)
   * @returns {Promise<Array>} List of colleges
   * 
   * Used for:
   * - Populating college dropdown on homepage
   * - Filtering products by college
   */
  getAllColleges: async () => {
    const response = await api.get('/colleges');
    return response.data;
  },

  /**
   * Get college by ID
   * @param {number} collegeId - College ID
   * @returns {Promise<Object>} College details
   */
  getCollegeById: async (collegeId) => {
    const response = await api.get(`/colleges/${collegeId}`);
    return response.data;
  },

  /**
   * Get college by code
   * @param {string} code - College code (e.g., IITD, IITB)
   * @returns {Promise<Object>} College details
   */
  getCollegeByCode: async (code) => {
    const response = await api.get(`/colleges/code/${code}`);
    return response.data;
  },
};

export default collegeService;